export const main = {
  extends: 'AppPage',
  // `AppPage` defaults to `flow: x; overflow: hidden` — override to the
  // column layout the preview chrome needs (navbar on top, Content row
  // filling the rest).
  flow: 'column',
  height: '100vh',
  width: '100vw',
  rowGap: 'X2',
  fontSize: 'Z2',

  // PreviewNavbar always mounts — even when project data is null or fetch
  // failed. Individual slots inside gate their reads with optional-chaining.
  PreviewNavbar: {},

  // FallbackBanner — shown when a fallback env was used instead of the
  // originally-requested one (e.g. "production" URL served "development" data).
  FallbackBanner: {
    hide: (el, s) => !s.root?.usedFallback,
    flow: 'row',
    align: 'center center',
    gap: 'A',
    padding: 'X B',
    background: 'yellow.1',
    color: 'title',
    fontSize: 'Z2',
    textAlign: 'center',

    Icon: {
      icon: 'info',
      boxSize: 'A A',
      color: 'yellow'
    },

    Text: {
      tag: 'span',
      text: (el, s) => {
        const resolved = s.root?.resolvedEnv || 'development'
        const requested = s.root?.requestedEnv || 'production'
        return `Showing ${resolved} env — ${requested} not published yet.`
      }
    }
  },

  AppPage: {
    flex: '1',
    flow: 'x',
    overflow: 'hidden',
    gap: 'X2',
    padding: '- X2 X2',

    // Error boundary — replaces Scene content when project fetch failed.
    // PreviewNavbar still mounts above (always rendered regardless of data).
    PreviewErrorBoundary: {
      hide: (el, s) => !s.root?.fetchError
    },

    // Left-hand sidebar — inline with Scene so opening it shrinks the
    // Scene width instead of overlaying.
    PreviewSidebar: {
      hide: (el, s) => !!s.root?.fetchError
    },

    CodePreviewWidget: {
      if: (_, s) => s.isCodeOpen && !s.root?.fetchError,
      width: 'G2',
      minWidth: 'F',
      height: '100%',
      borderRight: '1px solid',
      borderColor: 'line'
    },

    Scene: {
      flex: '1',
      hide: (el, s) => !!s.root?.fetchError
    }
  }
}
